const Email = ({ analytics = false, owner = false } = {}) => `
  id
  ${analytics ? `analytics` : ""}
  ${owner ? `ownerEmail` : ""}
  createdAt
  meta
  status
  title
  updatedAt
`;

export default Email;
